function $17da94a957c1e3ea$export$4385e60b38654f68() {
    let r = Math.round(Math.random() * 254 + 1);
    let g = Math.round(Math.random() * 254 + 1);
    let b = Math.round(Math.random() * 254 + 1);
    return {
        r: r,
        g: g,
        b: b
    };
}
function $17da94a957c1e3ea$export$d947e5f4f4c48d48() {
    let top = Math.round(Math.random() * 799 + 1);
    let left = Math.round(Math.random() * 799 + 1);
    return {
        top: top,
        left: left
    };
}


const $1f0dc3b9307be026$var$box = document.querySelector(".box");
const $1f0dc3b9307be026$var$randomColor = document.querySelector(".color");
const $1f0dc3b9307be026$var$button = document.querySelector(".btn");
$1f0dc3b9307be026$var$button.addEventListener("click", ()=>{
    const { r: r, g: g, b: b } = (0, $17da94a957c1e3ea$export$4385e60b38654f68)();
    $1f0dc3b9307be026$var$randomColor.style.backgroundColor = `rgb(${r},${g},${b})`;
    const { top: top, left: left } = (0, $17da94a957c1e3ea$export$d947e5f4f4c48d48)();
    $1f0dc3b9307be026$var$randomColor.style.top = `${top}px`;
    $1f0dc3b9307be026$var$randomColor.style.left = `${left}px`;
});


//# sourceMappingURL=JS4-HW6.b1787c43.js.map
